import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './components/Services';
import OurServicesPage from './pages/Our_Services';
import Portfolio from './pages/Our_Portfolio';
import BlogPage from './pages/Our_Blogs';
import Contact from './pages/Contact-Us';
import GetStartedPage from './pages/Get-Startes';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/our-services/:serviceId" element={<OurServicesPage />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/Blogs" element={<BlogPage />} />
          <Route path="/Blog/:id" element={<BlogPage />} />
          <Route path="/contact" element={<Contact />} />
           <Route path="/get-started" element={<GetStartedPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;